import { Grid, LinearProgress } from '@material-ui/core'
//import { FC } from 'react'
import { reduxForm, Field } from 'redux-form'
import {
  UpdateApplicationStatusByCode,
  CloseDialog
} from '../../../actions/types'
import { SubmitFormButton, DialogButtons } from '../../../components/Buttons'
import ErrorMessage from '../../../components/Error/ErrorMessage'
import { ReduxTextField } from '../../../components/FormInput/ReduxWrappers'
import i18n from '../../../translations/i18n'
import { UpdateByCodeStatus } from '../../../types/applications'
import { ReduxForm } from '../../../types/forms'
import { ReservedShowing, Showing } from '../../../types/showings'

interface UpdateApplicationStatusByCodeFormProps extends ReduxForm {
  t: i18n.TFunction
  updateByCode: UpdateApplicationStatusByCode
  byCodeStatus: UpdateByCodeStatus
  closeDialog: CloseDialog
}

export interface UpdateStatusByCodeFormData {
  status: UpdateByCodeStatus
  applicantMessage?: string
  showing?: ReservedShowing | Showing | undefined
}

const UpdateApplicationStatusByCodeForm = ({
  handleSubmit,
  submitting,
  error,
  t,
  updateByCode,
  byCodeStatus,
  closeDialog
}: UpdateApplicationStatusByCodeFormProps) => (
  <form onSubmit={handleSubmit(updateByCode)}>
    <Grid container spacing={2} style={{ paddingTop: '10px' }}>
      {byCodeStatus === 'notInterested' && (
        <Grid item xs={12}>
          <Field
            fullWidth
            name='applicantMessage'
            label={t(`showings.reserve.updateStatus.notInterested.field`)}
            component={ReduxTextField}
            multiline={true}
          />
        </Grid>
      )}
      <Grid item xs={12}>
        <DialogButtons
          closeDialog={closeDialog}
          dialogName={
            byCodeStatus === 'noAvailableTimes'
              ? 'ConfirmNoAvailableTimes'
              : 'ConfirmNotInterested'
          }
          ButtonTwo={
            <SubmitFormButton
              textColor='white'
              borderRadius='4px'
              variant='contained'
              submitting={submitting}
            />
          }
        />
      </Grid>
      <ErrorMessage error={error} />
      {submitting && <LinearProgress />}
    </Grid>
  </form>
)

export default reduxForm({
  form: 'UpdateApplicationStatusByCodeForm'
  // enableReinitialize: true,
  // destroyOnUnmount: false
})(UpdateApplicationStatusByCodeForm as any) as any
